export default __webpack_public_path__ + "static/pink_shape-3c175847659fc8a2323573c0f4c4f3b3.png";